module.exports = __webpack_public_path__ + "static/icons-33e0d73ad0be7db475a1f91c4bc66c7e.svg";